import {
    FormControl,
    FormLabel,
    Input,
    FormErrorMessage,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useResource } from "hooks/resources/providers/resourceProvider";
import { DataTableForm } from "components/elements/Datatable/data-table-form";
import LocationAutocomplete from "components/elements/LocationAutocomplete";
import {
    Property,
    PropertyCreateViewModel,
    PropertyUpdateViewModel,
} from "@common/properties/property.model";
import {
    propertyCreateSchema,
    propertyUpdateSchema,
} from "@common/properties/property.schema";

export function PropertyForm() {
    const { modal, params } = useResource<Property>();

    const item = modal.selectedOne;

    const defaultValues = item ? { ...item } : { ...params };

    const form = useForm<PropertyCreateViewModel | PropertyUpdateViewModel>({
        resolver: zodResolver(
            item ? propertyUpdateSchema : propertyCreateSchema
        ),
        defaultValues: defaultValues,
    });

    return (
        <DataTableForm<
            Property,
            PropertyCreateViewModel,
            PropertyUpdateViewModel
        >
            resource="Property"
            form={form}
        >
            <Input {...form.register("company")} type="hidden" />
            <FormControl isInvalid={!!form.formState.errors.name} isRequired>
                <FormLabel>Name</FormLabel>
                <Input
                    variant="primary"
                    type="text"
                    {...form.register("name")}
                    placeholder="Name"
                />
                <FormErrorMessage>
                    {form.formState.errors.name?.message}
                </FormErrorMessage>
            </FormControl>

            <FormControl isInvalid={!!form.formState.errors.purchase_date}>
                <FormLabel>Purchase Date</FormLabel>
                <Input
                    variant="primary"
                    type="date"
                    {...form.register("purchase_date")}
                    placeholder="Purchase Date"
                />
                <FormErrorMessage>
                    {form.formState.errors.purchase_date?.message}
                </FormErrorMessage>
            </FormControl>

            <FormControl isInvalid={!!form.formState.errors.completion_date}>
                <FormLabel>Completion Date</FormLabel>
                <Input
                    variant="primary"
                    type="date"
                    {...form.register("completion_date")}
                    placeholder="Completion Date"
                />
                <FormErrorMessage>
                    {form.formState.errors.completion_date?.message}
                </FormErrorMessage>
            </FormControl>

            <FormControl isInvalid={!!form.formState.errors.address}>
                <FormLabel>Address</FormLabel>
                <LocationAutocomplete
                    onChange={(val) => form.setValue("address", val.formatted)}
                    defaultValue={form.getValues("address")}
                    placeholder="Address"
                />
                <FormErrorMessage>
                    {form.formState.errors.address?.message}
                </FormErrorMessage>
            </FormControl>
        </DataTableForm>
    );
}
